/*
  All browsers except IE have a bug:

    If any "transform" rule applies to the parent,
    nested element with "position: fixed" expands to the parent height.

  Refs:

    - https://bugs.chromium.org/p/chromium/issues/detail?id=20574
    - https://stackoverflow.com/questions/2637058/positions-fixed-doesnt-work-when-using-webkit-transform
*/

import setCss from './set-css'
import getSize from './get-size'
import extractRawElm from './extract-raw-elm'
import viewportResize from './viewport-resize'

const TRANSFORM = 'transform'
const WILL_CHANGE = 'will-change'

const TRANSFORM_NONE = 'none'
const TRANSFORM_UNSET = 'unset'
const WILL_CHANGE_TRANSFORM = 'transform'

export default function isFixedPositionBroken($elm) {
  return staticCheck($elm) && dynamicCheck($elm)
}

function dynamicCheck($elm) {
  const elm = extractRawElm($elm)
  const div = document.createElement('div')
  setCss(div, { width: '100%', height: '100%', position: 'fixed' })
  elm.appendChild(div)
  div.offsetWidth /* eslint-disable-line no-unused-expressions */
  const size = getSize(div)
  const broken = false
    || size.width !== viewportResize.getWidth()
    || size.height !== viewportResize.getHeight()
  elm.removeChild(div)
  return broken
}

function staticCheck($elm) {
  const elm = extractRawElm($elm)
  if (hasBadStyles(elm)) {
    return true
  }

  const prntElm = elm.parentNode
  if (!prntElm || prntElm.nodeType !== 1 || prntElm === document) {
    return false
  }

  return staticCheck(prntElm)
}

function hasBadStyles($elm) {
  const elm = extractRawElm($elm)
  const styles = window.getComputedStyle(elm)
  const transform = styles[TRANSFORM]
  const willChange = styles[WILL_CHANGE]

  const hasTransform = transform !== TRANSFORM_NONE && transform !== TRANSFORM_UNSET
  const hasWillChange = willChange === WILL_CHANGE_TRANSFORM
  const hasBadStyles = hasTransform || hasWillChange
  return hasBadStyles
}
